import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";
import { getTodayFormatted } from "../../../shared/utils";

export const RESELLER_PACKAGE_FORM: { [key: string]: FormField } = {
    resellerPackageId: {
        id: 'resellerPackageId',
        type: 'hidden',
        name: 'resellerPackageId',
        label: 'ID',
        placeholder: "ID",
        value: 0,
        data: [],
        validators: [],
        errorMessages: {}
    },
    resellerId: {
        id: 'resellerId',
        type: 'select',
        name: 'resellerId',
        label: 'Rivenditore',
        placeholder: "Seleziona Rivenditore",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un rivenditore."
        }
    },
    courseId: {
        id: 'courseId',
        type: 'select',
        name: 'courseId',
        label: 'Corso',
        placeholder: "Seleziona Corso",
        value: '',
        data: [],
        validators: [Validators.required],
        errorMessages: {
            required: "Selezionare un corso."
        }
    },
    // isActive: {
    //     id: 'isActive',
    //     type: 'hidden',
    //     name: 'isActive',
    //     label: 'Stato',
    //     placeholder: "Stato",
    //     value: true,
    //     data: [],
    //     validators: [],
    //     errorMessages: {}
    // },
    initialAmount: {
        id: 'initialAmount',
        type: 'number',
        name: 'initialAmount',
        label: 'Numero licenze',
        placeholder: "Inserisci numero di licenze da assegnare",
        value: '',
        data: [],
        validators: [Validators.required, Validators.min(1)],
        errorMessages: {
            required: "Inserire il numero di licenze.",
            min: "Il numero di licenze deve essere almeno 1."
        }
    },
    orderType: {
        id: 'orderType',
        type: 'text',
        name: 'orderType',
        label: 'Codice Commessa',
        placeholder: "Inserisci codice commessa",
        value: '',
        data: [],
        validators: [Validators.required, Validators.maxLength(50)],
        errorMessages: {
            required: "Inserire il codice commessa.",
            maxlength: "Il codice commessa contenere al massimo 50 caratteri."
        }
    },
    creationDate: {
        id: 'creationDate',
        type: 'text',
        name: 'creationDate',
        label: 'Data Creazione',
        placeholder: "",
        value: getTodayFormatted(),
        data: [],
        validators: [],
        errorMessages: {},
        disabled: true
    }
};
